import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts";

export default function ApplicationCard({ app, toDDMMYYYYHHMM }) {
  const { t } = useLanguage();
  const endDate = app.positionEndDate || app.endDate || app.applicationEndDate || "";
  const endTime = app.positionEndTime || app.endTime || "";
  const firstSubmissionDate =
    app.firstSubmissionDate || app.submitDate || app.submittedAt || app.submissionDate || "";
  const lastResubmissionDate = app.lastResubmissionDate || app.resubmissionDate || "";
  const hasResubmission = Boolean(lastResubmissionDate);

  return (
    <div className="bg-white dark:bg-[var(--color-bg-card)] border border-patras-buccaneer/40 dark:border-[var(--color-border)] rounded-lg px-4 py-3 shadow-sm transition-[transform,box-shadow,background-color,border-color] duration-200 hover:shadow-md hover:scale-[1.005] hover:bg-patras-albescentWhite/20 dark:hover:bg-[var(--color-bg-muted)] dark:hover:border-[var(--color-border-accent)]">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div className="space-y-1">
          <h2 className="text-base font-semibold text-patras-buccaneer dark:text-[var(--color-text-secondary)]">
            {app.scientificField || "—"}
          </h2>
          <p className="text-sm text-gray-600 dark:text-[var(--color-text-secondary)]">
            {app.school || "—"} · {app.department || "—"}
          </p>
        </div>
        <div className="text-xs text-gray-500 dark:text-[var(--color-text-muted)] space-y-1">
          {hasResubmission ? (
            <>
              <div>
                {t("applicationCard.firstSubmission")}{" "}
                <span className="text-sm font-semibold text-gray-700 dark:text-[var(--color-text-secondary)]">
                  {firstSubmissionDate ? toDDMMYYYYHHMM(firstSubmissionDate) : "—"}
                </span>
              </div>
              <div>
                {t("applicationCard.resubmission")}{" "}
                <span className="text-sm font-semibold text-gray-700 dark:text-[var(--color-text-secondary)]">
                  {toDDMMYYYYHHMM(lastResubmissionDate)}
                </span>
              </div>
            </>
          ) : (
            <div>
              {t("applicationCard.submission")}{" "}
              <span className="text-sm font-semibold text-gray-700 dark:text-[var(--color-text-secondary)]">
                {firstSubmissionDate ? toDDMMYYYYHHMM(firstSubmissionDate) : "—"}
              </span>
            </div>
          )}
          <div>
            {t("applicationCard.deadline")}{" "}
            <span className="text-sm font-semibold text-gray-700 dark:text-[var(--color-text-secondary)]">
              {endDate ? toDDMMYYYYHHMM(endDate, endTime) : "—"}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="text-sm text-gray-700 dark:text-[var(--color-text-secondary)]">
          {t("applicationCard.points")} <span className="font-semibold">{app.totalPoints ?? "—"}</span>
        </div>
        <Link
          to={`/application-score/${app.id}`}
          className="inline-flex items-center justify-center bg-patras-buccaneer text-white px-4 py-2 rounded-md hover:bg-patras-sanguineBrown transition-colors"
        >
          {t("applicationCard.view")}
        </Link>
      </div>
    </div>
  );
}
